import { ERROR_PHONE_MESSAGE, MAX_PHONE_LENGTH, REQUIRED_FIELD_MESSAGE } from '@shared/constants/errorMessages';
import { FIELD_ID_EMAIL, FIELD_ID_PHONE, GuestInfo } from '@entities/leadCollector';
import { emailValidator } from '@pages/event/lib/validator';

export const validationFieldsGuest = async (guest: GuestInfo) => {
  for (const field of guest.FIO) {
    field.error = field.value ? '' : REQUIRED_FIELD_MESSAGE;
  }

  for (const field of guest.additionalFields) {
    const emailError = field.dbField === FIELD_ID_EMAIL ? (await emailValidator(field.value)) || '' : '';
    const phoneError =
      field.dbField === FIELD_ID_PHONE ? field.value?.length !== MAX_PHONE_LENGTH && ERROR_PHONE_MESSAGE : '';

    field.error = field.value ? emailError || phoneError || '' : REQUIRED_FIELD_MESSAGE;
  }
};
